import type { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
  target: string;
  children: ReactNode;
}

const DPortal: FC<Props> = ({ target, children }) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Fall back to <body> when the target mount point is absent (e.g. standalone
    // public layouts like the questionnaire, which don't render #d-app-content).
    setElement(document.getElementById(target) ?? document.body);
  }, [target]);

  return element ? createPortal(children, element) : null;
};

export default DPortal;
